import { Controller } from "web-ui/controller"
import * as Log from "web-ui/log"

// Connects to data-controller="switch"
export default class extends Controller {
  static events = {
    "change": "submitForm"
  }

  connect() {
    this.debug("Connect")
  }

  disconnect() {
    this.debug("Disconnect")
  }

  submitForm(e) {
    const option = e.target
    const form = option.form

    this.debug("Submitting form", { id: form.id, optionId: option.id })

    form.requestSubmit()
  }

  debug(message, data) {
    Log.debug("Switch - " + message, data)
  }
}
